import { render, staticRenderFns } from "./guanqiaStartLog.vue?vue&type=template&id=b5a61ce2&"
import script from "./guanqiaStartLog.vue?vue&type=script&lang=js&"
export * from "./guanqiaStartLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5a61ce2')) {
      api.createRecord('b5a61ce2', component.options)
    } else {
      api.reload('b5a61ce2', component.options)
    }
    module.hot.accept("./guanqiaStartLog.vue?vue&type=template&id=b5a61ce2&", function () {
      api.rerender('b5a61ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/guanqiaStartLog.vue"
export default component.exports